/** @jsx jsx */
import { jsx } from "frontend/src/utils/jsx"
import { useState } from "react"
import { SectionGrid, Flex } from "frontend/src/components/Layout"
import { BlockText } from "frontend/src/components/BlockText"

function NewsletterSignup({ title, backgroundColor, fontColor, buttonDesign }) {
  const [firstName, setFirstName] = useState("")
  const [emailValue, setEmailValue] = useState("")
  const generalStyles = {
    textAlign: "center",
    fontFamily: "heading",
    width: ["100%", "unset"],
    fontSize: "16px",
    lineHeight: 1.0,
    fontWeight: "light",
    textTransform: "uppercase",
    px: 7,
    py: 5,
    opacity: 1,
    cursor: "pointer",
    transition: "all 0.1s linear",
    ":focus": { outline: "none", opacity: "0.9" },
    ":active": { opacity: "0.8" },
    ":hover": { opacity: 0.6 },
  }
  const buttonStyles =
    buttonDesign === "outline"
      ? {
          ...generalStyles,
          backgroundColor: backgroundColor,
          color: fontColor,
          borderWidth: ["2px", "3px"],
          borderStyle: "solid",
          borderColor: fontColor,
        }
      : {
          ...generalStyles,
          backgroundColor: "almostBlack",
          color: "background",
          border: "none",
        }
  return (
    <SectionGrid sx={{ backgroundColor: backgroundColor, py: [8, 11], px: [5, 5, 0] }}>
      <SectionGrid.narrow>
        <Flex.column
          align="center"
          sx={{
            color: fontColor,
          }}
        >
          <div sx={{ mb: 7 }}>
            <BlockText
              style={{
                textAlign: "center",
              }}
              blocks={title}
            />
          </div>
          <form
            id="email_signup"
            action="https://hook.integromat.com/8pf5t7kev3k931umilola6f25s44yvo7"
            method="post"
            sx={{
              display: "flex",
              flexDirection: ["column", "row"],
              justifyContent: ["space-around", "center"],
              alignItems: ["center", "cemter", "center"],
              width: "100%",
            }}
          >
            <input type="hidden" name="g" value="WsHQ2g" />
            <input type="hidden" name="$fields" value="$first_name,$source" />
            <input type="hidden" name="$source" value="10% Gutschein Subscriber" />
            <input
              type="text"
              name="$first_name"
              placeholder="Vorname"
              onChange={e => setFirstName(e.target.value)}
              required
              value={firstName}
              sx={{
                width: ["100%", "calc(100% - 150px)"],
                maxWidth: ["unset", "450px", "370px"],
                height: "50px",
                backgroundColor: "#f6f6f6",
                border: "none",
                mb: [3, 0],
                mr: [0, 5],
                padding: 5,
                fontSize: 0,
                fontFamily: "body",
                lineHeight: 1.42857143,
                color: "#333333",
                verticalAlign: "middle",
                "&:active": {
                  border: "none",
                  outline: "none",
                },
                "&:focus": {
                  border: "none",
                  outline: "none",
                },
              }}
            />
            <input
              type="email"
              name="email"
              placeholder="E-Mail-Adresse"
              onChange={e => setEmailValue(e.target.value)}
              required
              value={emailValue}
              sx={{
                width: ["100%", "calc(100% - 150px)"],
                maxWidth: ["unset", "450px", "370px"],
                height: "50px",
                backgroundColor: "#f6f6f6",
                border: "none",
                mb: [3, 0],
                mr: [0, 5],
                padding: 5,
                fontSize: 0,
                fontFamily: "body",
                lineHeight: 1.42857143,
                color: "#333333",
                verticalAlign: "middle",
                "&:active": {
                  border: "none",
                  outline: "none",
                },
                "&:focus": {
                  border: "none",
                  outline: "none",
                },
              }}
            />
            <button
              type="submit"
              sx={{
                ...buttonStyles,
              }}
            >
              Anmelden
            </button>
          </form>
        </Flex.column>
      </SectionGrid.narrow>
      <script
        type="text/javascript"
        src="//www.klaviyo.com/media/js/public/klaviyo_subscribe.js"
      ></script>
    </SectionGrid>
  )
}

export { NewsletterSignup }
